import { Component, Pipe } from '@angular/core';

@Pipe({
  name: 'CustomCurrency',
})
export class CustomCurrencyPipe {
  transform(val: string) {
    let value = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(parseInt(val));
    return parseInt(val) >= 0 ? value : `(${value.replace('-', '')})`;
  }
}
